// extracted by mini-css-extract-plugin
export default {"list":"styles_list__loHEf","item":"styles_item__-V4B7","mail":"styles_mail__czaji","department":"styles_department__MbRho","data":"styles_data__8Kbbz"};